import api from '../api';
import errHandler from './_errhandler';


export const fetch = (appName, container, params = {}) => {
  return api.get(`/apps/${appName}/content/${container}`, { params })
    .then(res => res.data)
    .catch(errHandler);
};
